(() => {
  const HEADING_RE = /<(strong|b)(\s[^>]*)?>\s*([A-Z][^<]{0,80}:)\s*<\/\1>/g;
  const BULLET_RE = /[•●∙▪]/;
  const BULLET_SPLIT_RE = /\s*[•●∙▪]\s*/;

  function needsFormat(el) {
    if (el.querySelector('ul, ol, table, h1, h2, h3, h4, h5, h6')) return false;
    const html = el.innerHTML;
    const text = el.textContent || '';
    HEADING_RE.lastIndex = 0;
    const hasHeading = HEADING_RE.test(html);
    HEADING_RE.lastIndex = 0;
    return BULLET_RE.test(text) || hasHeading;
  }

  function bulletsToList(inner) {
    if (!BULLET_RE.test(inner)) {
      inner = inner.trim();
      return inner ? `<p>${inner}</p>` : '';
    }

    const parts = inner.split(BULLET_SPLIT_RE);
    const intro = (parts.shift() || '').trim();
    const items = parts.map((item) => item.trim()).filter(Boolean);
    const introText = intro.replace(/<[^>]+>/g, '').trim();
    let out = '';

    if (intro) {
      if (/^[A-Z][^:]{0,80}:$/.test(introText)) {
        out += `<h3 class="product-description__heading">${intro}</h3>`;
      } else {
        out += `<p>${intro}</p>`;
      }
    }

    if (items.length) {
      out += `<ul>${items.map((item) => `<li>${item}</li>`).join('')}</ul>`;
    }

    return out;
  }

  function formatDescription(el) {
    if (!el || el.dataset.klDescFormatted === 'true') return;
    if (!needsFormat(el)) return;

    let html = el.innerHTML.trim();
    html = html.replace(/&nbsp;/gi, ' ');
    html = html.replace(/<br\s*\/?>/gi, ' ');
    html = html.replace(/<\/p>\s*<p[^>]*>/gi, ' ');
    html = html.replace(/^<p[^>]*>/i, '');
    html = html.replace(/<\/p>$/i, '');
    html = html.replace(/<\/?div[^>]*>/gi, '');
    html = html.replace(/\s+/g, ' ').trim();

    HEADING_RE.lastIndex = 0;
    html = html.replace(
      HEADING_RE,
      '</p><h3 class="product-description__heading"><strong>$3</strong></h3><p>'
    );

    html = `<p>${html}</p>`;
    html = html.replace(/<p>\s*<\/p>/g, '');
    html = html.replace(/<p>\s*(<h3\b)/g, '$1');
    html = html.replace(/(<\/h3>)\s*<\/p>/g, '$1');
    html = html.replace(/<p>([\s\S]*?)<\/p>/g, (_, inner) => bulletsToList(inner));
    html = html.replace(/<p>\s*<\/p>/g, '');
    html = html.replace(/<p>\s*(<ul\b)/g, '$1');
    html = html.replace(/(<\/ul>)\s*<\/p>/g, '$1');

    el.innerHTML = html;
    el.dataset.klDescFormatted = 'true';
  }

  function run() {
    document.querySelectorAll('.product__description.rte').forEach(formatDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
